import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { DireccionTrabajosTitulacionArticulosDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class DireccionTrabajosTitulacionArticulosService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getDireccionTrabajosTitulacionArticulosService(): Observable<BodyListResponse<DireccionTrabajosTitulacionArticulosDTO>> {
    return this.http.get<BodyListResponse<DireccionTrabajosTitulacionArticulosDTO>>(API_URL + '/api/v1/direccionTrabajosTitulacionArticulos/todos');
  }

  guardarDireccionTrabajosTitulacionArticulosService(direccionTrabajosTitulacionArticulosDTO: DireccionTrabajosTitulacionArticulosDTO): Observable<DireccionTrabajosTitulacionArticulosDTO> {
    return this.http.post<DireccionTrabajosTitulacionArticulosDTO>(API_URL + '/api/v1/direccionTrabajosTitulacionArticulos', direccionTrabajosTitulacionArticulosDTO);
  }

  getDireccionTrabajosTitulacionArticulosPorCodigoDireccionTrabajosTitulacionArticulosService(codigoDireccionTrabajosTitulacionArticulos: string): Observable<BodyResponse<DireccionTrabajosTitulacionArticulosDTO>> {
    return this.http.get<BodyResponse<DireccionTrabajosTitulacionArticulosDTO>>(API_URL + '/api/v1/direccionTrabajosTitulacionArticulos/' + codigoDireccionTrabajosTitulacionArticulos);
  }
}
